import React from 'react';
import PropTypes from 'prop-types';

import Hero from '~/components/hero';

import {
    GlobalBlockOptions,
    AcfAttributes,
    DefaultGlobalBlockOptions,
    DefaultAcfAttributes,
    AcfLink
} from '~/utilities/propTypes';

const getVariantProps = ({ variant, includeGraphics }) => {
    let variantProps = {
        backgroundColor: 'darkBlue',
        graphicImage: includeGraphics ? ['blueHeroLeft', 'blueHeroRight'] : '',
        padding: 'medium',
        component: 'basic'
    };

    switch (variant) {
        case 'large-photo-dark':
            variantProps = {
                ...variantProps,
                backgroundColor: 'black',
                graphicImage: includeGraphics ? 'largePhotoHero' : '',
                component: 'largePhoto'
            };
            break;
        case 'large-photo-light':
            variantProps = {
                ...variantProps,
                backgroundColor: 'lightBlue',
                graphicImage: includeGraphics ? 'largePhotoHero' : '',
                component: 'largePhoto'
            };
            break;
        case 'photo-text-box':
            variantProps = {
                ...variantProps,
                backgroundColor: 'black',
                graphicImage: includeGraphics ? 'photoHero' : '',
                padding: 'large',
                component: 'photoTextBox'
            };
            break;
        default:
            break;
    }

    return variantProps;
};

const HeroBanner = ({
    variant = 'blue',
    includeGraphics = false,
    backgroundImageType = 'image',
    backgroundImage = null,
    lottieJson = null,
    title,
    copy = '',
    ctasVariant = 'ctas',
    ctas = [],
    appLinks = [],
    globalBlockOptions = DefaultGlobalBlockOptions,
    attributes = DefaultAcfAttributes
}) => (
    <Hero
        {...getVariantProps({ variant, includeGraphics })}
        {...{
            backgroundImage,
            backgroundImageType,
            lottieJson,
            title,
            copy,
            ctasVariant,
            ctas,
            appLinks,
            globalBlockOptions,
            attributes
        }}
    />
);

HeroBanner.propTypes = {
    variant: PropTypes.string,
    includeGraphics: PropTypes.bool,
    backgroundImageType: PropTypes.oneOf(['image', 'animation']),
    backgroundImage: PropTypes.shape({}),
    lottieJson: PropTypes.string,
    title: PropTypes.string.isRequired,
    copy: PropTypes.string,
    ctasVariant: PropTypes.string,
    ctas: PropTypes.arrayOf(
        PropTypes.shape({
            icon: PropTypes.string,
            link: AcfLink
        })
    ),
    appLinks: PropTypes.arrayOf(
        PropTypes.shape({
            linkUrl: PropTypes.string,
            badge: PropTypes.shape({})
        })
    ),
    globalBlockOptions: GlobalBlockOptions,
    attributes: AcfAttributes
};

export default HeroBanner;
